<template>
  <div class="mt-10 ProductsGrid">
    <LoadingProductCard v-for="item in [1, 2, 3, 4, 7]" :key="item" />
  </div>
</template>

<script setup lang="ts">
defineComponent({
  name: 'ProductsList',
});
defineProps({
  items: {
    type: Number,
    required: false,
    default: 12,
  },
});
</script>

<style lang="postcss" scoped>
.ProductsGrid {
  :deep(.card) {
    @media (max-width: 767px) {
      flex-shrink: 1;
      width: 100%;
    }
  }
}
.pagination {
  &:before,
  &:after {
    @apply mx-3 bg-primary-100;
    content: '';
    height: 2px;
    width: 18%;
  }

  @screen lg {
    &:before,
    &:after {
      width: 40%;
    }
  }
}
</style>
